import { Play } from "lucide-react";

export const VideoCard = ({ item, meta, testId, large = false }) => (
  <a
    href={item.url}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className="group block overflow-hidden rounded-md border border-line bg-card2 transition-colors duration-300 hover:border-ember/60"
  >
    <div className="relative aspect-video overflow-hidden">
      <img
        src={item.image}
        alt={item.title}
        loading="lazy"
        onError={(e) => {
          if (item.imageFallback && e.currentTarget.src !== item.imageFallback) e.currentTarget.src = item.imageFallback;
        }}
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
      <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-ember text-ink transition-transform duration-300 group-hover:scale-110">
          <Play className="ml-0.5 h-6 w-6 fill-current" />
        </span>
      </div>
    </div>
    <div className="p-5">
      <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-ember">{item.category}</p>
      <h3 className={`mt-2 line-clamp-3 font-display font-bold leading-snug text-cream transition-colors duration-300 group-hover:text-emberHover ${large ? "text-xl md:text-2xl" : "text-lg"}`}>
        {item.title}
      </h3>
      {meta && <p className="mt-3 text-sm text-ash">{meta}</p>}
    </div>
  </a>
);
